var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 21.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 10.2812C23.8895 10.2812 24.2631 10.436 24.5386 10.7114C24.814 10.9869 24.9688 11.3605 24.9688 11.75V23.5C24.9688 23.8895 24.814 24.2631 24.5386 24.5386C24.2631 24.814 23.8895 24.9688 23.5 24.9688H11.75C11.3605 24.9688 10.9869 24.814 10.7114 24.5386C10.436 24.2631 10.2812 23.8895 10.2812 23.5C10.2812 23.1105 10.436 22.7369 10.7114 22.4614C10.9869 22.186 11.3605 22.0312 11.75 22.0312H22.0312V11.75C22.0312 11.3605 22.186 10.9869 22.4614 10.7114C22.7369 10.436 23.1105 10.2812 23.5 10.2812Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0312 23.5C22.0312 23.1105 22.186 22.7369 22.4614 22.4614C22.7369 22.186 23.1105 22.0312 23.5 22.0312H35.25C35.6395 22.0312 36.0131 22.186 36.2886 22.4614C36.564 22.7369 36.7188 23.1105 36.7188 23.5C36.7188 23.8895 36.564 24.2631 36.2886 24.5386C36.0131 24.814 35.6395 24.9688 35.25 24.9688H24.9688V35.25C24.9688 35.6395 24.814 36.0131 24.5386 36.2886C24.2631 36.564 23.8895 36.7188 23.5 36.7188C23.1105 36.7188 22.7369 36.564 22.4614 36.2886C22.186 36.0131 22.0312 35.6395 22.0312 35.25V23.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/new-icon.92df3aa27c13ecfaeb98b37fc2531abd.svg";
export { ForwardRef as ReactComponent };